const specificPartNumbers = [
  "XM-PP2-3232-02",
  "XM-PP2-3232-01",
  "XM-PP2-1616-02",
  "XM-PP2-1616-01",
  "XM-BTHSG-2919-01",
  "XM-BTHSG-2919-02",
];

const specificFormFactors = [
  "PPT_1616_0",
  "PPT_3232_1",
  "MHO_2919_5",
];

export {
    specificPartNumbers,
    specificFormFactors
};